import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nonCanadianPostalValidator(countryCode: string): ValidatorFn {
  const regex =
    /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden =
      countryCode === 'CA' && !regex.test(control.value) && control.value;
    return forbidden ? { nonCanadianPostal: true } : null;
  };
}
